<template>
    <div class="loading"><img
            src="https://cdn.prod.website-files.com/686b0fce62ce6721b0225627/68959d93e5c6c85ff1726169_Loading%20200px-200px.gif"
            loading="lazy" width="66" alt="">
        <div>Loading...</div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: "loadingComp"
})
</script>